import React, { useState } from "react";
import { CheckIcon } from "@heroicons/react/24/outline";
import dayjs from "dayjs";
import { toast } from "react-toastify";

const EditableDateCell = ({
  value,
  id,
  field,
  onSave,
  className = "",
  inputClassName = "px-2 py-1 border border-gray-300 rounded-md text-sm text-gray-900",
  displayClassName = "text-sm font-medium text-gray-900 text-center",
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [selectedDate, setSelectedDate] = useState(value?.split("T")[0] || "");

  const handleSave = () => {
    if (selectedDate) {
      onSave({ id, field, value: selectedDate });
    }
    setIsEditing(false);
  };

  return (
    <div className={`flex items-center  space-x-2 cursor-pointer ${className}`}>
      <div
        onClick={() => {
          if (value !== undefined && value !== null && value !== "————") {
            navigator.clipboard.writeText(value.toString());
          }
        }}
        onDoubleClick={() => setIsEditing(true)}
        className="relative"
      >
        {isEditing ? (
          <input
            type="date"
            className={inputClassName}
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
            onBlur={handleSave}
            autoFocus
          />
        ) : (
          <span className={`${displayClassName} relative`} title={selectedDate}>
            <div className="absolute -top-1 -right-1 w-0.5 h-0.5 bg-blue-500 rounded-full"></div>
            {value ? dayjs.utc(value).format("DD/MM/YYYY") : "————"}
          </span>
        )}
      </div>
      {isEditing && (
        <button
          onClick={handleSave}
          className="p-1 text-gray-400 hover:text-gray-600"
        >
          <CheckIcon className="h-5 w-5" />
        </button>
      )}
    </div>
  );
};

export default EditableDateCell;
